import {colors} from '../components/Theme/WebTheme';
const drawerWidth = 260;

const transition = {
  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
};

const containerFluid = {
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
  width: "100%"
};

const container = {
  ...containerFluid,
  "@media (min-width: 576px)": {
    maxWidth: "540px"
  },
  "@media (min-width: 768px)": {
    maxWidth: "720px"
  },
  "@media (min-width: 992px)": {
    maxWidth: "960px"
  },
  "@media (min-width: 1200px)": {
    maxWidth: "1140px"
  }
};

// Flat card design - no shadows
const card = {
  display: "inline-block",
  position: "relative",
  width: "100%",
  margin: "25px 0",
  border: `1px solid ${colors.BORDER_BACKGROUND}`,
  borderRadius: "8px",
  color: colors.DARK,
  background: colors.WHITE
};

const defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: "300",
  lineHeight: "1.5em"
};

// Updated color palette
const primaryColor = colors.PRIMARY;
const warningColor = colors.PRIMARY;
const dangerColor = colors.PRIMARY;
const successColor = colors.ACCENT_SOLID;
const infoColor = colors.PRIMARY;
const roseColor = colors.PRIMARY;
const grayColor = colors.DARK;
const headerColor = colors.Header_Background;
const PrimaryButtonColor = colors.Button_Primary;
const SecondaryButtonColor = colors.Button_Secondary;

// Flat card headers - no shadows or gradients
const warningCardHeader = {
  color: colors.WHITE,
  background: colors.PRIMARY,
  borderRadius: "8px 8px 0 0"
};
const successCardHeader = {
  color: colors.WHITE,
  background: colors.ACCENT_SOLID,
  borderRadius: "8px 8px 0 0"
};
const dangerCardHeader = {
  color: colors.WHITE,
  background: colors.PRIMARY,
  borderRadius: "8px 8px 0 0"
};
const infoCardHeader = {
  color: colors.WHITE,
  background: colors.PRIMARY,
  borderRadius: "8px 8px 0 0"
};
const primaryCardHeader = {
  color: colors.WHITE,
  background: colors.PRIMARY,
  borderRadius: "8px 8px 0 0"
};
const roseCardHeader = {
  color: colors.WHITE,
  background: colors.PRIMARY,
  borderRadius: "8px 8px 0 0"
};

const cardActions = {
  margin: "0 20px 10px",
  paddingTop: "10px",
  borderTop: `1px solid ${colors.BORDER_BACKGROUND}`,
  height: "auto",
  ...defaultFont
};

const cardHeader = {
  margin: "-30px 15px 0",
  borderRadius: "8px",
  padding: "15px"
};

// Flat design - minimal shadow
const defaultBoxShadow = {
  border: `1px solid ${colors.BORDER_BACKGROUND}`,
  borderRadius: "8px",
  padding: "10px 0",
  transition: "all 150ms ease 0s"
};

// Flat box shadow
const boxShadow = {};

// No box shadows for flat design
const primaryBoxShadow = {};
const infoBoxShadow = {};
const successBoxShadow = {};
const warningBoxShadow = {};
const dangerBoxShadow = {};
const roseBoxShadow = {};

const title = {
  color: colors.DARK,
  margin: "1.75rem 0 0.875rem",
  textDecoration: "none",
  fontWeight: "700",
  fontFamily: `"Roboto Slab", "Times New Roman", serif`
};

const cardTitle = {
  ...title,
  marginTop: ".625rem"
};

const cardLink = {
  "& + $cardLink": {
    marginLeft: "1.25rem"
  }
};

const cardSubtitle = {
  marginBottom: "0",
  marginTop: "-.375rem"
};

export {
  //variables
  drawerWidth,
  transition,
  container,
  containerFluid,
  boxShadow,
  card,
  defaultFont,
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  title,
  cardTitle,
  cardLink,
  cardSubtitle,
  headerColor,
  PrimaryButtonColor,
  SecondaryButtonColor,
};
